import { currenciesZodSchema } from '@mint-lib/currencies-helpers';
import { createResponseSchema } from '@mint-sdk/api-core';
import z from 'zod';

const summarySchema = z.object({
  dateFrom: z.string(),
  dateTo: z.string(),
  name: z.string(),
  currency: currenciesZodSchema,
  plannedBudget: z.string(),
});

const mediaPlanSummarySchema = z.object({
  ...summarySchema.shape,
  plannedActivitiesBudget: z.string(),
  unplannedActivitiesBudget: z.string(),
});

export const mediaPlanSummaryResponseSchema = createResponseSchema(
  mediaPlanSummarySchema,
);

const activitySummarySchema = z.object({
  ...summarySchema.shape,
  plannedMediaPlanBudget: z.string(),
});

export const activitySummaryResponseSchema = createResponseSchema(
  activitySummarySchema,
);

const flightSummarySchema = z.object({
  ...summarySchema.shape,
  plannedActivityBudget: z.string(),
  plannedMediaPlanBudget: z.string(),
  allocatedBudget: z.string(),
  allocatedBudgetPercentage: z.number(),
  unallocatedBudget: z.string(),
  unallocatedBudgetPercentage: z.number(),
});

export const flightSummaryResponseSchema =
  createResponseSchema(flightSummarySchema);
